import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "d-inline-block mr-2"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    var _a;
    const _component_v_chip = _resolveComponent("v-chip");
    return (((_a = _ctx.appliedFilters) === null || _a === void 0 ? void 0 : _a.priceRange) != null)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(_component_v_chip, {
                color: "primary",
                variant: "flat",
                "append-icon": "icon-cancel-circled",
                onClick: _cache[0] || (_cache[0] = ($event) => (_ctx.clearFilter()))
            }, {
                default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.appliedFilters.priceRange.start) + "€ - " + _toDisplayString(_ctx.appliedFilters.priceRange.end) + "€ ", 1)
                ]),
                _: 1
            })
        ]))
        : _createCommentVNode("", true);
}
